const EMAIL_REGEX = new RegExp(
    /^([A-Za-z0-9_\-.]+)@([A-Za-z0-9_\-.]+)\.([A-Za-z]{2,5})$/
);

const IsValidEmail = (emailAddress: string) => EMAIL_REGEX.test(emailAddress);

export { IsValidEmail };
